import type { FootnoteVariant } from "@/interfaces";

export interface FootnoteLink {
  text: string;
  url: string;
}

export interface FootnoteConfig {
  /** The disclaimer text template with placeholders for links */
  disclaimerText: string;
  /** Links to be displayed in the footer */
  links: FootnoteLink[];
  /** Path to the "powered by" logo image */
  poweredByImage: string | null;
  /** Alt text for the powered by image */
  poweredByAlt: string;
}

const SUPERPLAY_CONFIG: FootnoteConfig = {
  disclaimerText:
    "By completing this purchase, you agree to our {termsLink} and confirm you are at least the required age to be eligible to play",
  links: [{ text: "Terms of Service", url: "https://www.superplay.co/terms/" }],
  poweredByImage: null,
  poweredByAlt: "",
};

const SUPERPLAY_CALIFORNIA_CONFIG: FootnoteConfig = {
  disclaimerText:
    "By completing this purchase, you agree to our {termsLink} and confirm you are at least the required age to be eligible to play. This purchase is for license to the virtual item, as described in our Terms of Service",
  links: [{ text: "Terms of Service", url: "https://www.superplay.co/terms/" }],
  poweredByImage: null,
  poweredByAlt: "",
};

const STASH_CONFIG: FootnoteConfig = {
  disclaimerText:
    "This purchase grants a license to the software or digital content. By proceeding, you confirm you're an adult according to your country laws and agree to be bound by {eulaLink}, {refundLink}, and {privacyLink}.",
  links: [
    { text: "Stash's EULA", url: "https://www.stash.gg/legal/end-user-licence-agreement" },
    { text: "Refund Policy", url: "https://www.stash.gg/legal/refund-policy" },
    { text: "Privacy Policy", url: "https://www.stash.gg/legal/privacy-policy" },
  ],
  poweredByImage: "/img/pwdbystash.png",
  poweredByAlt: "Powered by Stash",
};

const FOOTNOTE_CONFIGS: Record<FootnoteVariant, FootnoteConfig> = {
  superplay: SUPERPLAY_CONFIG,
  stash: STASH_CONFIG,
};

const FOOTNOTE_CONFIGS_CALIFORNIA: Record<FootnoteVariant, FootnoteConfig> = {
  superplay: SUPERPLAY_CALIFORNIA_CONFIG,
  stash: STASH_CONFIG, // Stash uses the same config for all locations
};

/**
 * Get the footnote configuration for a given variant
 * @param variant - The footnote variant (superplay or stash)
 * @param isCaliforniaUser - Whether the user is in California (affects superplay variant)
 * @returns The footnote configuration
 */
export function getFootnoteConfig(
  variant: FootnoteVariant = "superplay",
  isCaliforniaUser: boolean = false
): FootnoteConfig {
  if (isCaliforniaUser) {
    return FOOTNOTE_CONFIGS_CALIFORNIA[variant] || SUPERPLAY_CALIFORNIA_CONFIG;
  }
  return FOOTNOTE_CONFIGS[variant] || SUPERPLAY_CONFIG;
}

/**
 * Get the default footnote variant
 */
export function getDefaultFootnoteVariant(): FootnoteVariant {
  return "superplay";
}

